const compatModules = {};import * as Mod1 from "./discourse/components/edit-enforce";
compatModules["discourse/components/edit-enforce"] = Mod1;

export * as discourse$components$edit__enforce$$__module from "./discourse/components/edit-enforce";
export {
default as discourse$components$edit__enforce$$default
} from "./discourse/components/edit-enforce";
import * as Mod2 from "./discourse/connectors/category-custom-settings/waze-require-edit-reason-settings.gjs";
compatModules["discourse/connectors/category-custom-settings/waze-require-edit-reason-settings"] = Mod2;

export * as discourse$connectors$category__custom__settings$waze__require__edit__reason__settings$$__module from "./discourse/connectors/category-custom-settings/waze-require-edit-reason-settings.gjs";
export {
default as discourse$connectors$category__custom__settings$waze__require__edit__reason__settings$$default
} from "./discourse/connectors/category-custom-settings/waze-require-edit-reason-settings.gjs";
import * as Mod3 from "./discourse/connectors/composer-action-after/edit-enforce.gjs";
compatModules["discourse/connectors/composer-action-after/edit-enforce"] = Mod3;

export * as discourse$connectors$composer__action__after$edit__enforce$$__module from "./discourse/connectors/composer-action-after/edit-enforce.gjs";
export {
default as discourse$connectors$composer__action__after$edit__enforce$$default
} from "./discourse/connectors/composer-action-after/edit-enforce.gjs";
import * as Mod4 from "./discourse/initializers/init-composer-events";
compatModules["discourse/initializers/init-composer-events"] = Mod4;

export * as discourse$initializers$init__composer__events$$__module from "./discourse/initializers/init-composer-events";
export {
default as discourse$initializers$init__composer__events$$default
} from "./discourse/initializers/init-composer-events";
import * as Mod5 from "./discourse/services/enforce-edit-reason";
compatModules["discourse/services/enforce-edit-reason"] = Mod5;

export * as discourse$services$enforce__edit__reason$$__module from "./discourse/services/enforce-edit-reason";
export {
default as discourse$services$enforce__edit__reason$$default
} from "./discourse/services/enforce-edit-reason";
export default compatModules;
